export default __webpack_public_path__ + "static/media/sanghamitra.dce79029.jpeg";